import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const DiscoverWrap = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 120px;
  @media (max-width: 769px) {
    flex-direction: column;
    margin-top: 0;
  }
`;

export const Title = styled.h1`
  font-size: 48px;
  line-height: 57px;
  color: ${colors.GREY_DARK};
  font-family: ${fonts.abhayaBold};
  @media (max-width: 769px) {
    font-size: 36px;
    line-height: 42px;
    margin-top: 46px;
    margin-bottom: 45px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  @media (min-width: 769px) {
    flex-direction: row;
    max-width: 1167px;
    width: 100%;
    margin: 0 auto;
    justify-content: center;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 769px) {
    flex: 0 0 33.333%;
    max-width: 33.333%;
    width: 100%;
  }
`;

export const ImageWrap = styled.div`
  flex: 0 0 300px;
  max-width: 300px;
  width: 100%;
  height: 0;
  padding-top: 117.432%;
  position: relative;
  @media (min-width: 1200px) {
    padding-top: 411px;
  }
`;

export const Text = styled.p`
  color: ${colors.GREY_SEMIDARK};
  font-family: ${fonts.latoRegular};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 27px;
  max-width: 344px;
  width: 100%;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 22px;
  @media (min-width: 769px) {
    font-size: 18px;
    margin: 28px 0;
  }
`;

export const TextTitle = styled.div`
  color: ${colors.GREY_DARK};
  font-family: ${fonts.latoRegular};
  font-weight: bold;
  font-size: 20px;
  line-height: 36px;
  margin-bottom: 9px;
`;

export const TextComing = styled.div`
  color: ${colors.GREY};
  font-family: ${fonts.latoRegular};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
`;
